import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import './../../styles/admin/chat_history.css';
import * as globals from './../../components/GlobalScripts.js';

const Admin_chat_history = () => {
    let path_api = localStorage.getItem('path_api');
    const navigate = useNavigate();
    const { id, id2 } = useParams();
    const location = useLocation();
    const [sender, setSender] = useState({});
    const [reciever, setReciever] = useState({});
    const [messages, setMessages] = useState([]);

    useEffect(() => {
        get_accounts();
        getMessages();
    }, [location]);

    const get_accounts = async () => {
        globals.openViewCharge();

        await axios.post(`${path_api}/default/get_profile.php`, {
            rute: globals.getRuteBackend(),
            keylogin: id
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setSender(response.data.profile);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se obtuvo el perfil sender",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al cargar el perfil sender",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        });

        await axios.post(`${path_api}/default/get_profile.php`, {
            rute: globals.getRuteBackend(),
            keylogin: id2
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setReciever(response.data.profile);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se obtuvo el perfil reciever",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al cargar el perfil reciever",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        });

        globals.closeViewCharge();
    };

    const getMessages = () => {
        axios.post(`${path_api}/chat/get_messages.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            key_primary: id,
            key_secundary: id2
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setMessages(response.data.messages);
            }
        }).catch(err => {
            console.error(err);
        });
    };

    return (
        <>
            <button onClick={() => navigate(-1)} className="flex-row gap-5 button-back">
                <svg width="20" viewBox="0 0 100 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M24.163 41.125L38.7085 55.6658L38.7088 55.6662C39.2779 56.2353 39.7294 56.9109 40.0374 57.6545C40.3454 58.3981 40.5039 59.1951 40.5039 60C40.5039 60.8049 40.3454 61.6018 40.0374 62.3454C39.7294 63.089 39.2779 63.7647 38.7088 64.3338C38.1397 64.9029 37.464 65.3544 36.7204 65.6624C35.9768 65.9704 35.1798 66.1289 34.375 66.1289C33.5701 66.1289 32.7732 65.9704 32.0296 65.6624C31.2859 65.3544 30.6103 64.9029 30.0412 64.3338L5.04386 39.3365C5.04297 39.3356 5.04207 39.3347 5.04118 39.3338M24.163 41.125L36.5875 12.2125C36.878 11.9219 37.1085 11.577 37.2658 11.1974C37.423 10.8178 37.5039 10.4109 37.5039 10C37.5039 9.5891 37.423 9.18222 37.2658 8.8026C37.1085 8.42298 36.878 8.07805 36.5875 7.7875C36.2969 7.49695 35.952 7.26647 35.5724 7.10923C35.1928 6.95198 34.7859 6.87105 34.375 6.87105C33.9641 6.87105 33.5572 6.95198 33.1776 7.10923C32.798 7.26647 32.453 7.49695 32.1625 7.7875L7.1625 32.7875C6.87148 33.0778 6.64059 33.4226 6.48305 33.8023C6.32551 34.1819 6.24441 34.589 6.24441 35C6.24441 35.411 6.32551 35.818 6.48305 36.1977C6.64059 36.5774 6.87148 36.9222 7.1625 37.2125L5.04118 39.3338M24.163 41.125H90.625C92.2494 41.125 93.8074 40.4797 94.956 39.331C96.1047 38.1824 96.75 36.6244 96.75 35C96.75 33.3755 96.1047 31.8176 94.956 30.669C93.8074 29.5203 92.2495 28.875 90.625 28.875H24.163L38.7085 14.3342L38.7088 14.3338C39.2779 13.7647 39.7294 13.089 40.0374 12.3454C40.3454 11.6018 40.5039 10.8049 40.5039 10C40.5039 9.19513 40.3454 8.39815 40.0374 7.65455C39.7294 6.91095 39.2779 6.2353 38.7088 5.66618C38.1397 5.09705 37.464 4.6456 36.7204 4.33759C35.9768 4.02958 35.1799 3.87105 34.375 3.87105C33.5701 3.87105 32.7731 4.02958 32.0296 4.33759C31.286 4.6456 30.6103 5.09705 30.0412 5.66618L5.04386 30.6635L7.16215 32.7871L5.04118 30.6662M24.163 41.125L5.04118 30.6662M5.04118 39.3338C4.47204 38.7654 4.02043 38.0905 3.71213 37.3475C3.40336 36.6034 3.24441 35.8056 3.24441 35C3.24441 34.1943 3.40336 33.3966 3.71213 32.6525C4.02043 31.9095 4.47204 31.2346 5.04118 30.6662M5.04118 39.3338L5.04118 30.6662" fill="var(--color-primary)" stroke="var(--color-primary)" strokeWidth="6" />
                </svg>
                <h4 style={{ color: "var(--color-primary)" }}>Volver</h4>
            </button>
            <div className='container-chat page-home'>
                <div className="middle-side">
                    <div className="conversation">
                        {messages.map((msg, i) => (
                            <div key={i} className={`chat-message ${msg.sender === id ? 'sent' : msg.sender === id2 ? 'received' : 'system'}`}>
                                <span>
                                    {String(msg?.rute_adjunto) != '' && (
                                        <Link to={path_api + msg?.rute_adjunto} className='img-on-msg' target='_blank'>
                                            <img src={path_api + msg?.rute_adjunto}></img>
                                        </Link>
                                    )}
                                    <p>{msg.msg}</p>
                                    {msg.sender == id && msg.seen == 1 && (
                                        <p className='status-msg'>
                                            <svg viewBox="0 0 77 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M43.0625 2.0625C43.9429 1.22431 45.1145 0.760918 46.3301 0.770116C47.5457 0.779313 48.7102 1.26038 49.5778 2.1118C50.4454 2.96322 50.9484 4.1184 50.9805 5.33359C51.0126 6.54878 50.5714 7.72892 49.75 8.625L24.8125 39.8125C24.3837 40.2744 23.8662 40.645 23.2908 40.9023C22.7155 41.1596 22.0942 41.2982 21.4641 41.3099C20.8339 41.3215 20.2079 41.206 19.6235 40.9702C19.039 40.7344 18.5081 40.3832 18.0625 39.9375L1.525 23.4C1.06446 22.9709 0.695067 22.4534 0.438868 21.8784C0.182668 21.3034 0.0449069 20.6827 0.033802 20.0533C0.0226971 19.4239 0.138476 18.7987 0.374232 18.215C0.609989 17.6313 0.960892 17.1011 1.40601 16.656C1.85113 16.2109 2.38134 15.86 2.96501 15.6242C3.54869 15.3885 4.17387 15.2727 4.80326 15.2838C5.43266 15.2949 6.05337 15.4327 6.62836 15.6889C7.20336 15.9451 7.72086 16.3145 8.15 16.775L21.2375 29.8563L42.9375 2.2L43.0625 2.0625ZM37.3125 34.1875L43.0625 39.9375C43.508 40.3822 44.0385 40.7326 44.6224 40.9678C45.2063 41.2031 45.8315 41.3183 46.4609 41.3066C47.0903 41.2949 47.7108 41.1566 48.2856 40.8999C48.8604 40.6432 49.3775 40.2734 49.8062 39.8125L74.7563 8.625C75.2044 8.18251 75.5589 7.65423 75.7984 7.07172C76.0379 6.48921 76.1575 5.86441 76.1502 5.23463C76.1428 4.60485 76.0086 3.98301 75.7556 3.40624C75.5026 2.82947 75.136 2.3096 74.6776 1.87768C74.2192 1.44576 73.6785 1.11065 73.0877 0.89235C72.4969 0.674052 71.8682 0.577048 71.2391 0.607133C70.61 0.637217 69.9934 0.793774 69.4261 1.06745C68.8589 1.34113 68.3526 1.72631 67.9375 2.2L46.2312 29.8563L43.2 26.8187L37.3125 34.1875Z" fill="black" />
                                            </svg>
                                        </p>
                                    )}
                                    {msg.sender == id && msg.seen == 0 && (
                                        <p className='status-msg'>
                                            <svg viewBox="0 0 52 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M43.5625 2.0625C44.4429 1.22431 45.6145 0.760918 46.8301 0.770116C48.0457 0.779313 49.2102 1.26038 50.0778 2.1118C50.9454 2.96322 51.4484 4.1184 51.4805 5.33359C51.5126 6.54877 51.0714 7.72892 50.25 8.625L25.3125 39.8125C24.8837 40.2744 24.3662 40.645 23.7908 40.9023C23.2155 41.1596 22.5942 41.2982 21.9641 41.3099C21.3339 41.3215 20.7079 41.206 20.1235 40.9702C19.539 40.7344 19.0081 40.3832 18.5625 39.9375L2.025 23.4C1.56446 22.9709 1.19507 22.4534 0.938868 21.8784C0.682668 21.3034 0.544906 20.6827 0.533801 20.0533C0.522696 19.4239 0.638477 18.7987 0.874233 18.215C1.10999 17.6313 1.46089 17.1011 1.90601 16.656C2.35113 16.2109 2.88134 15.86 3.46501 15.6242C4.04869 15.3885 4.67387 15.2727 5.30327 15.2838C5.93266 15.2949 6.55337 15.4327 7.12836 15.6889C7.70336 15.9451 8.22086 16.3145 8.65 16.775L21.7375 29.8562L43.4438 2.2L43.5625 2.0625Z" fill="black" />
                                            </svg>
                                        </p>
                                    )}
                                    <p className='date-msg'>
                                        {(() => {
                                            const date = new Date(msg.createAt);
                                            const now = new Date();
                                            const diffMs = now - date;
                                            const diffMinutes = Math.floor(diffMs / (1000 * 60));
                                            const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
                                            const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

                                            if (diffDays > 15) {
                                                const day = String(date.getDate()).padStart(2, '0');
                                                const month = String(date.getMonth() + 1).padStart(2, '0');
                                                const hours = String(date.getHours()).padStart(2, '0');
                                                const minutes = String(date.getMinutes()).padStart(2, '0');
                                                return `${day} del ${month} a las ${hours}:${minutes}`;
                                            } else if (diffDays >= 1) {
                                                return `hace ${diffDays} ${diffDays === 1 ? 'día' : 'días'}`;
                                            } else if (diffHours >= 1) {
                                                return `hace ${diffHours} ${diffHours === 1 ? 'hora' : 'horas'}`;
                                            } else if (diffMinutes >= 1) {
                                                return `hace ${diffMinutes} ${diffMinutes === 1 ? 'minuto' : 'minutos'}`;
                                            } else {
                                                return "justo ahora";
                                            }
                                        })()}
                                    </p>
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Admin_chat_history;